














































import { Component, Mixins } from "vue-property-decorator";
import page from "@/mixins/page";
import utils from "defi/utils";

@Component
class LoanPage extends Mixins(page) {
  loading = false;

  schemes: any = [];

  get title() {
    return this.$t("common.debit") as string;
  }

  get formatedSchemes() {
    return this.schemes.map(scheme => {
      const progress = utils.enums.getSchemeProgressMeta(scheme.progress);
      return {
        id: scheme.id,
        name: scheme.pledge_asset.symbol,
        icon: scheme.pledge_asset.icon,
        interestRatioText: this.$common.utils.number.toPercent(
          scheme.interest_ratio,
          false,
          -1
        ),
        exchangeRatioText: this.$common.utils.number.toPercent(
          scheme.exchange_ratio,
          false,
          -1
        ),
        progressText: this.$t(progress.text),
        progressColor: progress.color
      };
    });
  }

  mounted() {
    this.requestDebitSchemes();
  }

  handleToDetail(item) {
    this.$common.utils.helper.toFusionPath(this, "defi", {
      name: "loan-id",
      params: {
        id: item.id
      }
    });
  }

  async handleConnect() {
    this.$common.utils.helper.message(
      this,
      {
        title: this.$t("defi.debit.warn.title") as string,
        description: this.$t("defi.debit.warn.description") as string,
        ok: this.$t("defi.debit.warn.ok") as string
      },
      { onOK: () => this.requestCustomerService() }
    );
  }

  async requestCustomerService() {
    if (this.$store.getters["auth/isLogged"]) {
      const res = await this.$api.defi.getCustomerService();
      if (res.url) {
        window.location.href = res.url;
      }
    } else {
      this.$common.utils.helper.requestLogin(this);
    }
  }

  async requestDebitSchemes() {
    this.loading = true;
    try {
      const schemes = await this.$api.defi.getDebitSchemes();
      this.schemes = schemes;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default LoanPage;
